export const CONGESTION_DIRECTION_CONSUME = 'Verbruik';
export const CONGESTION_DIRECTION_SUPPLY = 'Teruglevering';
export const FALLBACK_VALUE = 'Onbekend';
